import { Path, Svg, G, Polygon } from '@react-pdf/renderer';


export const EmailIcon = ({ color }: { color: string }) => {
    return (
      <Svg width="16px" height="16px" viewBox="0 0 24 24" style={{marginTop: '4px', marginBottom: '4px'}}>
        <Path
          fill={color}
          d="M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4zM20,8l-8,5L4,8V6l8,5l8-5V8z"
        />
      </Svg>
    );
  };